import { Col, Row } from "reactstrap";
import InstallationDetail from "../components/installations/InstallationDetail";

export default function InstallationDetailView({ match }) {
  return (
    <div className="content">
      <Row>
        <Col md="12">
          <InstallationDetail key={match.params.identifier} identifier={match.params.identifier} />
        </Col>
      </Row>
    </div>
  );
}
